import { jsx } from "panel";
import { CheckboxEl } from "common/components/checkbox";
import { SelectEl } from "common/components/select";
import { InputEl } from "common/components/input";
import { ButtonEl } from "common/components/button";
import { ToastPortalEl } from "common/components/toast-portal";
import { SpinnerEl } from "common/components/spinner";
import { SpinnerSize } from "common/components/spinner/types";
import { ButtonSize, ButtonTheme } from "common/components/button/constants";
import { SignUpStep } from "./constants";
export function template() {
  const {
    error,
    formErrors,
    formValues,
    notification,
    step,
    waitingForResponse
  } = this.state;
  const TermsOfUseCheckbox = () => /* @__PURE__ */ jsx("div", { sel: ".auth-form-field-row", style: {
    display: "flex"
  }, "data-sentry-component": "TermsOfUseCheckbox", "data-sentry-source-file": "template.tsx" }, /* @__PURE__ */ jsx(CheckboxEl, { sel: ".signup-checkbox", attrs: {
    elref: "terms-of-use",
    checked: formValues.agreedToTermsOfUse
  }, on: {
    click: this.helpers.handleTermsOfUseCheckboxClick
  }, "data-sentry-element": "CheckboxEl", "data-sentry-source-file": "template.tsx" }), /* @__PURE__ */ jsx("div", { sel: ".auth-form-field-content" }, "Agreed to", /* @__PURE__ */ jsx("a", { attrs: {
    href: "/legal/terms-of-use/",
    class: "mp-link legal-link",
    target: "_blank"
  } }, "terms of use"), "and", /* @__PURE__ */ jsx("a", { attrs: {
    href: "/legal/privacy-policy/",
    class: "mp-link legal-link",
    target: "_blank"
  } }, "privacy statements"), ".", formErrors.agreedToTermsOfUse ? /* @__PURE__ */ jsx("div", { sel: ".auth-form-error-msg" }, formErrors.agreedToTermsOfUse) : null));
  const DepartmentSelect = () => /* @__PURE__ */ jsx("div", { sel: ".auth-form-field-row", "data-sentry-component": "DepartmentSelect", "data-sentry-source-file": "template.tsx" }, /* @__PURE__ */ jsx("div", { sel: ".auth-form-field-label" }, "Department"), /* @__PURE__ */ jsx(SelectEl, { attrs: {
    elref: "department-select",
    options: this.helpers.DEPARTMENT_OPTIONS,
    "selected-option": formValues.department || "Select department",
    "validation-status": this.helpers.getValidationStatus("department"),
    "menu-height": 400
  }, on: {
    change: (ev) => this.helpers.handleDepartmentChange(ev.detail.item)
  }, "data-sentry-element": "SelectEl", "data-sentry-source-file": "template.tsx" }), formErrors.department ? /* @__PURE__ */ jsx("div", { sel: ".auth-form-error-msg" }, formErrors.department) : null);
  const NameInput = () => /* @__PURE__ */ jsx("div", { sel: ".auth-form-field-row", "data-sentry-component": "NameInput", "data-sentry-source-file": "template.tsx" }, /* @__PURE__ */ jsx(InputEl, { attrs: {
    elref: "name-input",
    "field-id": "full-name",
    label: "Your name",
    placeholder: "First & Last Name",
    "validation-status": this.helpers.getValidationStatus("name"),
    "error-message": formErrors.name
  }, props: {
    value: formValues.name
  }, on: {
    input: (ev) => this.helpers.handleFieldInput(ev, "name"),
    blur: () => this.helpers.handleFieldBlur("name")
  }, "data-sentry-element": "InputEl", "data-sentry-source-file": "template.tsx" }));
  const EmailInput = () => /* @__PURE__ */ jsx("div", { sel: ".auth-form-field-row", "data-sentry-component": "EmailInput", "data-sentry-source-file": "template.tsx" }, /* @__PURE__ */ jsx(InputEl, { attrs: {
    elref: "email-input",
    "field-id": "email",
    label: "Email Address",
    placeholder: "email@address.com",
    "validation-status": this.helpers.getValidationStatus("email"),
    "error-message": formErrors.email
  }, props: {
    value: formValues.email
  }, on: {
    input: (ev) => this.helpers.handleFieldInput(ev, "email"),
    blur: () => this.helpers.handleFieldBlur("email")
  }, "data-sentry-element": "InputEl", "data-sentry-source-file": "template.tsx" }));
  const PasswordInput = () => /* @__PURE__ */ jsx("div", { sel: ".auth-form-field-row", "data-sentry-component": "PasswordInput", "data-sentry-source-file": "template.tsx" }, /* @__PURE__ */ jsx(InputEl, { attrs: {
    elref: "password-input",
    "field-id": "password",
    type: "password",
    label: "Password",
    placeholder: "Password",
    "validation-status": this.helpers.getValidationStatus("password"),
    "error-message": formErrors.password
  }, props: {
    value: formValues.password
  }, on: {
    input: (ev) => this.helpers.handleFieldInput(ev, "password"),
    blur: () => this.helpers.handleFieldBlur("password")
  }, "data-sentry-element": "InputEl", "data-sentry-source-file": "template.tsx" }));
  const ContinueButton = () => /* @__PURE__ */ jsx("div", { sel: ".auth-form-field-row", "data-sentry-component": "ContinueButton", "data-sentry-source-file": "template.tsx" }, /* @__PURE__ */ jsx(ButtonEl, { sel: ".auth-form-field-action-button", attrs: {
    elref: "continue-button",
    size: ButtonSize.Large,
    theme: ButtonTheme.Primary,
    disabled: waitingForResponse
  }, on: {
    click: this.helpers.handleContinue
  }, "data-sentry-element": "ButtonEl", "data-sentry-source-file": "template.tsx" }, "Get Started"));
  const SignInWithGoogle = () => /* @__PURE__ */ jsx(null, null, /* @__PURE__ */ jsx("div", { sel: ".auth-form-field-row" }, /* @__PURE__ */ jsx("div", { sel: "#g_id_onload.gid", attrs: {
    "data-client_id": this.helpers.getSignInWithGoogleClientId(),
    "data-callback": "handleGoogleCredentialResponse",
    "data-auto_prompt": "false"
  } }), /* @__PURE__ */ jsx("div", { sel: ".g_id_signin", attrs: {
    "data-type": "standard",
    "data-size": "large",
    "data-theme": "filled_blue",
    "data-text": "continue_with",
    "data-shape": "rectangular",
    "data-logo_alignment": "left",
    "data-width": 293
  } })), /* @__PURE__ */ jsx("div", { sel: ".auth-form-divider" }, /* @__PURE__ */ jsx("div", { sel: ".auth-form-divider-content" }, "or sign up with email")));
  const AlreadyAUserFooter = (_ref) => {
    let {
      next
    } = _ref;
    const nextParam = next ? "?next=".concat(encodeURIComponent(next)) : "";
    return /* @__PURE__ */ jsx("div", { sel: ".auth-form-footer", "data-sentry-component": "AlreadyAUserFooter", "data-sentry-source-file": "template.tsx" }, "Already a user?", /* @__PURE__ */ jsx("a", { attrs: {
      href: "/login/".concat(nextParam),
      class: "mp-link"
    }, style: {
      "padding-left": "5px"
    } }, "Log in."));
  };
  const ConfirmMagicLink = () => {
    const email = formValues.email;
    return /* @__PURE__ */ jsx(null, null, /* @__PURE__ */ jsx("div", { sel: ".auth-form-copy-content.center" }, "We sent a verification email to"), /* @__PURE__ */ jsx("div", { sel: ".auth-form-copy-content-bold.center" }, email));
  };
  const ResendMagicLinkFooter = () => /* @__PURE__ */ jsx("div", { sel: ".auth-form-footer", on: {
    click: this.helpers.sendRegistrationMagicLink
  }, "data-sentry-component": "ResendMagicLinkFooter", "data-sentry-source-file": "template.tsx" }, "Not seeing the email?", /* @__PURE__ */ jsx("a", { attrs: {
    class: "mp-link"
  }, style: {
    "padding-left": "5px"
  } }, "Resend"));
  const isMagicLinkRegistration = this.state.formValues.enableMagicLinkRegistration && !this.state.formValues.socialCredential;
  return /* @__PURE__ */ jsx("form", { attrs: {
    name: "signup",
    id: "signup"
  }, "data-sentry-component": "template", "data-sentry-source-file": "template.tsx" }, error ? /* @__PURE__ */ jsx(ToastPortalEl, { props: {
    toast: {
      isStatic: true,
      message: error,
      type: "error",
      closeToastCallback: this.helpers.handleToastClosed
    }
  } }) : null, notification ? /* @__PURE__ */ jsx(ToastPortalEl, { props: {
    toast: {
      isStatic: true,
      message: notification,
      type: "success",
      closeToastCallback: this.helpers.handleToastClosed
    }
  } }) : null, isMagicLinkRegistration ? step === SignUpStep.UserCredentials ? /* @__PURE__ */ jsx(null, null, /* @__PURE__ */ jsx("h1", { sel: ".auth-form-title.center" }, "Let's get started"), /* @__PURE__ */ jsx(SignInWithGoogle, null), /* @__PURE__ */ jsx(EmailInput, null), /* @__PURE__ */ jsx(TermsOfUseCheckbox, null), /* @__PURE__ */ jsx(ContinueButton, null), /* @__PURE__ */ jsx(AlreadyAUserFooter, { next: this.attr("next") })) : /* @__PURE__ */ jsx(null, null, /* @__PURE__ */ jsx(ConfirmMagicLink, null), /* @__PURE__ */ jsx(ResendMagicLinkFooter, null)) : step === SignUpStep.UserCredentials && !formValues.socialCredential ? /* @__PURE__ */ jsx(null, null, /* @__PURE__ */ jsx("h1", { sel: ".auth-form-title.center" }, "Let's get you set up"), /* @__PURE__ */ jsx(SignInWithGoogle, null), /* @__PURE__ */ jsx(NameInput, null), /* @__PURE__ */ jsx(DepartmentSelect, null), /* @__PURE__ */ jsx(EmailInput, null), /* @__PURE__ */ jsx(PasswordInput, null), /* @__PURE__ */ jsx(TermsOfUseCheckbox, null), /* @__PURE__ */ jsx(ContinueButton, null), /* @__PURE__ */ jsx(AlreadyAUserFooter, { next: this.attr("next") })) : /* @__PURE__ */ jsx("div", { sel: ".auth-form-title.center" }, /* @__PURE__ */ jsx(SpinnerEl, { attrs: {
    size: SpinnerSize.Large
  } })));
}
